module.exports = __webpack_public_path__ + "static/media/spongebob-fail.5aa350e8.mp3";